import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="bg-[#FAF7F2] py-12 md:py-18 px-5 md:px-12 overflow-hidden" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-128">
        {/* Decorative Element */}
        <motion.div initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#C9A96E]/10 border border-[#C9A96E]/30 mb-6" data-id="element-129">
          <SparklesIcon className="w-7 h-7 text-[#C9A96E]" data-id="element-130" />
        </motion.div>

        {/* Intro */}
        <p className="text-lg md:text-xl text-[#1C1C1C]/70 mb-4 font-light" data-id="element-131">
          Te presento:
        </p>

        {/* Product Name */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#1C1C1C] leading-tight mb-5" data-id="element-132">
          "Hogar de Revista:{' '}
          <span className="italic text-[#C9A96E]" data-id="element-133">El Método Perfect-Hang</span>"
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-[#1C1C1C]/80 leading-relaxed max-w-2xl mx-auto" data-id="element-134">
          He descodificado la{' '}
          <span className="font-semibold text-[#1C1C1C]" data-id="element-135">
            ingeniería estética
          </span>{' '}
          de las mansiones más lujosas de USA para que puedas replicarla en tu
          sala, con tu máquina de coser de siempre y con un{' '}
          <span className="font-semibold text-[#C9A96E]" data-id="element-136">
            presupuesto de bodega
          </span>
          .
        </p>
      </motion.div>
    </section>;
}